module.exports = __webpack_public_path__ + "img/ic_process_no2.1955cf70.png";